import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(
  key: string,
  content: string,
  attr: "name" | "property" = "name"
) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    setMeta("og:title", title, "property");
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
    }
    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, keywords]);
}